// config
import * as http from 'utils/http';
import config from 'config';
import { SETTINGS } from 'modules/emergencies/constants';
// utils

const getAlerts = async (args) => {
  const page = args[1];
  const url = `${config.API_URL}price-negotiation/alerts/?page_size=${SETTINGS.ALERTS_PAGE_SIZE}&ordering=-timestamp&page=${page}`;
  const data = await http.get(url);
  return data;
};

export default getAlerts;
